import { render, staticRenderFns } from "./DetailListUnderViewWithAnswer.vue?vue&type=template&id=30a1fdfa"
import script from "./DetailListUnderViewWithAnswer.vue?vue&type=script&lang=js"
export * from "./DetailListUnderViewWithAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports